import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";
import { faPlusSquare, faSave } from "@fortawesome/free-regular-svg-icons";
import { faCloudUploadAlt, faPlusCircle, faSearch, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { TranslateService } from "@ngx-translate/core";
import { SwalComponent, SwalPortalTargets } from "@sweetalert2/ngx-sweetalert2";
import { DropTargetOptions, HttpClientUploadService, InputFileOptions } from "@wkoza/ngx-upload";
import { UserService } from "app/core/services/admin/user/user.service";
import { LayoutService } from "app/core/services/global/layout/layout.service";
import { ElementService } from "app/core/services/pim/element.service";
import { TagService } from "app/core/services/tag/tag.service";
import { ThumbnailsService } from "app/core/services/thumbnails/thumbnails.service";
import { UploadService } from "app/core/services/upload/upload.service";
import { MediaType } from "app/shared/helpers/media-type.helper";
import { ThumbButtons } from "app/shared/helpers/thumb-buttons";
import { MaestroTags } from "app/shared/models";
import { ACL } from "app/shared/models/acl";
import { LazyLoadDataModel } from "app/shared/models/lazy-load-data";
import { Thumb } from "app/shared/models/thumb";
import { MAESTRO_ROUTES } from "app/shared/routes";
import { LazyLoadEvent, SelectItem } from "primeng-lts/api";
import { Subject, Subscription } from "rxjs";
import { map } from "rxjs/operators";
import Swal from "sweetalert2";

@Component({
    selector: "app-element-update-media",
    templateUrl: "./element-update-media.component.html",
    styleUrls: ["./element-update-media.component.scss"],
})
export class ElementUpdateMediaComponent implements OnInit, OnDestroy /*, ControlValueAccessor*/ {
    private elementId: number;
    private subscriptions: Subscription[] = [];

    public elementMedias: Thumb[] = [];
    public mediasModal: Thumb[] = [];
    public mediasLinkFiltered: Thumb[] = [];
    public selectedMedias: number[] = [];
    state: string = "all";
    medias = [];
    private _acceptList = [];
    tabIndex = 0;

    options: DropTargetOptions;

    optionsInput: InputFileOptions;

    readonly faUpload = faCloudUploadAlt;
    readonly routes = MAESTRO_ROUTES;

    public disabled = true;

    claroAvailable = false;

    public faSearch = faSearch;
    allTags = [];

    public buttons = ThumbButtons.asPimButtons();

    sortOptions: SelectItem[] = []; // Sort data based on media fields
    recordsFiltered: number = 0;
    globalFilter: string = "";
    currentDatatableFilters: LazyLoadEvent = {}; // Use to reload data when search filter is used
    filters: any = {
        tags: [],
        type: [], // Contains extension
    };

    uploadImage: any;

    eventsSubject: Subject<Thumb[]> = new Subject<Thumb[]>(); // Used to update pim media part when unlink or add media(s)

    @ViewChild("createModal", { static: true }) private swalModal: SwalComponent;
    @ViewChild("importSwal") importSwal: SwalComponent;

    formArray: FormArray;
    mediaTypes: string[] = [];

    readonly faSave = faSave;
    readonly faPlus = faPlusCircle;
    readonly faTrash = faTrashAlt;

    @Input() forElementMedia: boolean = true;
    @Input() idElementValue: number;
    @Input() idInput: number = -1;
    @Input() indexCollection: number = -1;
    @Input() singleSelection: boolean = false;
    @Input() elementMediasFromParent: any = [];
    @Input() isMediaField: boolean = false;
    acl: ACL;
    readonly faPlusSquare = faPlusSquare;

    @Output() mediaChange = new EventEmitter<any>();

    linkAdded = false;
    private mergedMediasModal = [];

    constructor(
        private elementService: ElementService,
        private layout: LayoutService,
        private _thumbnailService: ThumbnailsService,
        private sanitizer: DomSanitizer,
        private _route: ActivatedRoute,
        public swalTargets: SwalPortalTargets,
        private _translateService: TranslateService,
        private _userService: UserService,
        private formBuilder: FormBuilder,
        private _uploadService: UploadService,
        public uploader: HttpClientUploadService,
        private _tagService: TagService
    ) {}

    ngOnInit(): void {
        this.acl = this._userService.getUserAclFromToken();

        if (this.forElementMedia) {
            if (this.acl.SYSPAD_PIM_MEDIA_CREATE) {
                this.layout.actionButton.enable = true;
            }

            this.layout.breadcrumb.setPath({ routerLink: null, name: "breadcrumb.pim.media.title" }, 3);

            this.layout.actionButton.title = "pim.media.add";
            this.subscriptions.push(this.layout.actionButton.click$.subscribe(() => this.openDamModal()));

            this.elementId = Number(this._route.parent.snapshot.paramMap.get("id"));
        }

        /**
         * Get all medias linked to the element or element value
         */
        this._thumbnailService.getElementOrElementValueMedias(this.forElementMedia, this.idElementValue + "_" + this.indexCollection + "_" + this.idInput).subscribe((medias) => {
            this.elementMedias = medias;
            this.mediasLinkFiltered = this.elementMedias;
        });

        if (this.elementMediasFromParent !== false && this.elementMediasFromParent !== null && this.elementMediasFromParent.length) {
            this.setElementMedias(this.elementMediasFromParent);
        } else {
            this.getElementMedias();
        }

        this.mediasLinkFiltered = this.elementMedias;

        this.formArray = this.formBuilder.array([]);

        this.mediaTypes = Object.keys(MediaType);

        // Get available media types
        this._uploadService.getMediaTypes().subscribe((data) => {
            this._acceptList = [];

            data.map((v) => v.header).forEach((header) => {
                this._acceptList.push(...header.split(","));
            });

            this.options = {
                color: "dropZoneColor",
                colorDrag: "dropZoneColorDrag",
                colorDrop: "dropZoneColorDrop",
                multiple: true,
                accept: this._acceptList,
            };

            this.optionsInput = {
                multiple: true,
                accept: this._acceptList,
            };
        });

        this.disabled = true;
        this.uploader.onAddToQueue$.subscribe(() => (this.disabled = false));
        
        if(!this.isMediaField){
            this._tagService.setModulePath("dam");
            
            this._tagService
                .getAllTags()
                .pipe(map((r: any) => r.data))
                .subscribe((tags: MaestroTags) => {
                    this.allTags = tags.map((t) => ({ id: t.id, name: t.name }));
                });
        }
    }

    ngOnDestroy(): void {
        this.layout.actionButton.enable = false;
        this.layout.actionButton.title = null;
        this.layout.breadcrumb.setPath(null, 3);
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        this.layout.sidebar.enable = true;
        this.mediasLinkFiltered = [];
        this._thumbnailService.sendValuesObservables(this.mediasLinkFiltered);
        this.eventsSubject.next(this.mediasLinkFiltered);
        
    }

    /**
     * Prepare a media to be linked
     *
     * @param event
     */
    selectMedia(event: Event): void {
        const element = event.target as HTMLInputElement;
        const value = Number(element.value);

        if (element.checked) {
            const found = this.selectedMedias.find((id) => value === id);

            if (!found) {
                this.selectedMedias.push(value);
            }
        } else {
            for (let i = 0; i < this.selectedMedias.length; i++) {
                if (this.selectedMedias[i] === value) {
                    this.selectedMedias.splice(i, 1);
                }
            }
        }
    }

    /**
     * Open selection modal
     */
    private openDamModal(): void {
        this.resetSelectedMedias(); // Ensure that on cancel, close and confirm modal we reset selected medias
        this.swalModal.fire();
    }

    /**
     * Link media to this element
     */
    addSelectedMedias(): void {
        let newMedia = false;

        if (this.selectedMedias.length) {
            newMedia = true;
        }

        let medias = this.elementService.manageMedia(true, this.elementMedias, this.selectedMedias, this.mergedMediasModal);

        if (this.formArray.length && this.formArray.valid) {
            this.formArray.controls.map((formControlMedia: FormGroup) => {
                if (formControlMedia.value.link && formControlMedia.value.type) {
                    let position = 1;

                    if (medias.length) {
                        // Find same type
                        let filtered = medias.filter((m) => {
                            return m.type == formControlMedia.value.type;
                        });

                        if (filtered.length) {
                            // Find last position
                            const lastMedia = filtered.reduce((prev, current) => (prev && prev.position > current.position ? prev : current));
                            position = lastMedia.position + 1;
                        }
                    }

                    medias.push({
                        id: null,
                        link: formControlMedia.value.link,
                        position: position,
                        type: formControlMedia.value.type,
                        loadMetadata: formControlMedia.value.loadMetadata,
                    });

                    newMedia = true;
                }
            });

            this.formArray.clear();
        }

        if (newMedia && medias.length) {
            this.elementService.saveMedias(medias, this.forElementMedia ? this.elementId : this.idElementValue, this.forElementMedia, this.indexCollection, this.idInput).subscribe((_) => {
                this.mediaChange.emit(medias);
                this.getElementMedias();

                Swal.close();
            });
        }
    }

    /**
     * Unlink a media from the element
     * @param id
     */
    unlinkMedia(id: number): void {
        let unlinkIndex = this.elementMedias.findIndex((media) => media.id == id);
        this.elementMedias.splice(unlinkIndex, 1);
        this.elementMedias.filter((media) => media.id !== id);
        const medias = this.elementService.manageMedia(false, this.elementMedias);

        this.elementService.saveMedias(medias, this.forElementMedia ? this.elementId : this.idElementValue, this.forElementMedia, this.indexCollection, this.idInput).subscribe((_) => {
            this.mediaChange.emit(medias);
            this.getElementMedias();
        });
    }

    /**
     * Get all linked media from the api
     */
    getElementMedias(): void {
        let method = "getMedias";

        if (!this.forElementMedia) {
            method = "getElementValueMedias";
        }

        this.elementService[method](this.forElementMedia ? this.elementId : this.idElementValue, this.indexCollection, this.idInput).subscribe((medias: any) => {
            this.setElementMedias(medias.data);
        });
    }

    private setElementMedias(medias): void {
        const values = [];
        for (const dataKey of medias) {
            values.push(new Thumb().deserialize(dataKey));
        }

        this.mediasLinkFiltered = values;
        this._thumbnailService.sendValuesObservables(values, this.forElementMedia, !this.forElementMedia ? this.idElementValue + "_" + this.indexCollection + "_" + this.idInput : null);
        this.eventsSubject.next(this.mediasLinkFiltered); // Will notify the child component which will reload the data structure without the need to pass it as input (break the dataview's paginator)
    }

    /**
     * Get thumb for each media
     * @param param0
     * @returns
     */
    public getThumb({ binImage }: any) {
        let img =
            "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";
        if (binImage) {
            img = binImage;
        }

        return this.sanitizer.bypassSecurityTrustUrl(`data:image/jpeg;base64, ${img}`);
    }

    /**
     * Search media by a value | tag
     */
    // searchLinkMedias(value: string): void { // @TODO: See if we keep this kind of search or not
    //     if (value.length < 3) {
    //         this.mediasLinkFiltered = this.elementMedias;
    //         return;
    //     }

    //     this.elementService.filterMediaSearch.next(value);

    //     this.mediasLinkFiltered = this.elementMedias.filter(media => {
    //         return media.name.toLowerCase().includes(value.toLowerCase())
    //             || media.tags.map(tag => tag.name).some(tagName => tagName.toLowerCase().includes(value.toLowerCase()));
    //     });
    // }

    loadList(event: LazyLoadEvent): void {
        event.globalFilter = this.globalFilter; // Need to be forced since dataview will not bind it himself

        const customFilters = this.getCustomFilters();

        const requestFilters: LazyLoadDataModel = { lazyLoadFilters: event, customFilters: customFilters, state: this.state };

        this.subscriptions.push(
            this._thumbnailService.getDataviewMedias(JSON.stringify(requestFilters)).subscribe((resp) => {
                const data = resp.data;

                // this.mediasModal = data.medias.filter((media: Thumb) => !this.elementMedias.map((v: Thumb) => v.id).includes(media.id)); // Hide linked medias but breaks pagination
                this.mediasModal = data.medias; // Replaced when change pagination so only selected medias from last page index focused are added : need another variable to send to manageMedia() : mergedMediasModal

                data.medias.forEach((dm) => {
                    let found = this.mergedMediasModal.find((m) => m.id === dm.id);

                    if (undefined === found) {
                        this.mergedMediasModal.push(dm);
                    }
                });

                let translatedOptions = [];
                this.sortOptions = data.sortOptions.forEach((option) => {
                    option.label = this._translateService.instant("dataview.sortField." + option.label) + " " + this._translateService.instant("dataview.sortParameter." + option.translationKey);
                    translatedOptions.push(option);
                });

                this.sortOptions = translatedOptions;
                this.recordsFiltered = data.recordsFiltered;
                this.currentDatatableFilters = event;
            })
        );
    }

    loadListWithSearch(value: string): void {
        this.globalFilter = value;

        if ("" !== value) {
            this.currentDatatableFilters.first = 0;
        }

        this.loadList(this.currentDatatableFilters);
    }

    resetSelectedMedias(): void {
        this.uploader.queue = [];
        this.selectedMedias = [];
        this.globalFilter = "";
        this.filters.tags = [];
        this.filters.type = [];
        this.mediasModal = [];
        this.mergedMediasModal = [];
    }

    manageFilter(event: any, selected: boolean = true, filter: string = "tags"): void {
        const objectProperty = event.hasOwnProperty("id");
        if (objectProperty) {
            const found = this.filters[filter].find((t) => (objectProperty ? event.id === t.id : event === t));

            if (selected) {
                if (!found) {
                    this.filters[filter].push(event);
                    this._tagService.setTagsFilter(this.filters[filter]);
                    this.loadList(this.currentDatatableFilters);
                }
            } else {
                if (found) {
                    const index = this.filters[filter].findIndex((f) => (objectProperty ? event.id === f.id : event === f));
                    this.filters[filter].splice(index, 1);
                    this._tagService.setTagsFilter(this.filters[filter]);
                    this.loadList(this.currentDatatableFilters);
                }
            }
        } else {
            if (Array.isArray(event)) {
                this.filters[filter] = [];
                event.forEach((tag) => {
                    const objectProperty = event.hasOwnProperty("id");
                    const found = this.filters[filter].findIndex((t) => (objectProperty ? tag.id === t.id : tag === t));

                    if (found < 0) {
                        this.filters[filter].push(tag);
                    }
                });
                this._tagService.setTagsFilter(this.filters[filter]);
                this.loadList(this.currentDatatableFilters);
            }
        }
    }

    getCustomFilters(): any {
        let customFilters = { ...this.filters };

        Object.keys(customFilters).forEach((cf) => {
            customFilters[cf] = this.filters[cf].map((f) => f.id);
        });

        return customFilters;
    }

    changeHideExpireMedia(event) {
        this.state = event;
        this.loadList(this.currentDatatableFilters);
    }

    reorderMediaPosition(event: any) {
        this.mediaChange.emit(event.allMedias);
        this.elementService.saveMedias(event.allMedias, this.forElementMedia ? this.elementId : this.idElementValue, this.forElementMedia, this.indexCollection, this.idInput).subscribe((_) => {
            this.getElementMedias();
        });
    }

    addMediaLink(): void {
        const formGroup = this.formBuilder.group({
            link: ["", Validators.required],
            type: ["", Validators.required],
            loadMetadata: [false],
        });

        this.formArray.push(formGroup);
        this.formArray.markAsDirty();
        this.formArray.updateValueAndValidity();
        this.linkAdded = true;
    }

    deleteMediaLink(index: number): void {
        this.formArray.removeAt(index);
        this.linkAdded = false;
    }

    upload() {
        let isPicto = false;
        let isClaro = false;

        if (this.acl.MAESTRO_DAM_PICTO_CREATE === 1) {
            isPicto = $("#picto:checked").length === 1;
        }

        if (this.claroAvailable === true) {
            isClaro = $("#claro:checked").length === 1;
        }
        this._uploadService
            .uploadMedias(
                this.uploader.queue.map((fi) => fi.file),
                isPicto,
                isClaro
            )
            .subscribe((data) => {
                const importedMedias = data.data;
                let method = this.forElementMedia ? "getMedias" : "getElementValueMedias";

                this.elementService[method](this.forElementMedia ? this.elementId : this.idElementValue, this.indexCollection, this.idInput).subscribe((data: any) => {
                    const elementMedias = data.data;

                    let position = elementMedias.length;
                    importedMedias.forEach((importedMedia) => {
                        position++;
                        let type = Object.keys(MediaType).find((key) => MediaType[key] === Object.values(MediaType).find((value) => value.indexOf(importedMedia.extension) != -1));
                        elementMedias.push({
                            id: importedMedia.id,
                            link: importedMedia.thumbPath,
                            position: position,
                            type: type,
                            loadMetadata: null,
                        });
                    });

                    const mediasData = this.elementService.manageMedia(true, elementMedias);

                    this.elementService.saveMedias(mediasData, this.forElementMedia ? this.elementId : this.idElementValue, this.forElementMedia, this.indexCollection, this.idInput).subscribe((_) => {
                        this.mediaChange.emit(mediasData);
                        this.getElementMedias();
                        this.uploader.queue = [];
                        Swal.close();
                    });
                });
            });
    }
}
